import Form from '../../common/form';
import Ga from '../../common/ga';
import Navigation from '../../common/navigation';
import { initializeRealtorMessagePopin } from '../../common/popin.es6';
import * as RealtorMap from '../../common/realtor-map.es6';
import { bindForm } from '../../common/tagging';
import Wa from '../../common/wa';

/**
 * Open transaction detail popin
 */
function openTransactionDetailPopin(requestId, pastSaleId) {
    $.magnificPopup.open(
        {
            type: 'ajax',
            fixedContentPos: 'fixed',
            items: {
                src: `/rapport-biens-vendus/${requestId}/details/${pastSaleId}`,
            },
            callbacks: {
                ajaxContentAdded() {
                    // carousel picked from price page
                    const scrollDuration = 250;
                    const buttonClass = 'reference-popin__gallery-button';
                    let scrollPending = false;
                    const $html = this.content;

                    function onGalleryButtonClick() {
                        const horizontalOffset = 20;
                        const $gallery = $html.find('[data-reference-gallery]');
                        const $button = $(this);
                        const isNext = $button.hasClass(`${buttonClass}--next`);
                        const scrollLeft = $gallery.scrollLeft();
                        const canScrollToLeft = scrollLeft > 0;
                        const canScrollToRight =
                            scrollLeft < $gallery[0].scrollWidth - $gallery.innerWidth();

                        if (
                            scrollPending ||
                            (isNext && !canScrollToRight) ||
                            (!isNext && !canScrollToLeft)
                        ) {
                            return;
                        }

                        function scrollGalleryTo(scrollTarget) {
                            scrollPending = true;
                            $gallery.animate({ scrollLeft: scrollTarget }, scrollDuration, () => {
                                scrollPending = false;
                            });
                        }

                        function scrollGalleryToPicture($picture) {
                            if ($picture.length > 0) {
                                const leftOffset =
                                    Math.ceil($picture.position().left) +
                                    parseInt($picture.css('margin-left'), 10);
                                scrollGalleryTo(`+=${leftOffset}`);
                            }
                        }

                        $gallery.children().each(function childrenGalleryEach() {
                            const $picture = $(this);
                            if ($picture.position().left > (isNext ? 1 : -1) * horizontalOffset) {
                                scrollGalleryToPicture(isNext ? $picture : $picture.prev());
                                return false;
                            }

                            return undefined;
                        });
                    }

                    $html.on('click', `.${buttonClass}`, onGalleryButtonClick);

                    Navigation.disablePageScroll();
                },
                close() {
                    Navigation.enablePageScroll();
                },
            },
        },
        0,
    );
}

/**
 * Handle success and failure of form to get past sales report PDF
 */
function handleGetPdfForm() {
    const $form = $('[data-past-sales-report-get-pdf-form]');

    bindForm($form, {
        category: 'Résultat Rapport BV',
        actionPrefix: 'past_sales_report:result:get_pdf_by_email',
        label: 'past_sales_report:result:get_pdf_by_email',
    });

    Form.bindAjaxForm($form, $('[data-past-sales-report-get-pdf-success]'), true);
}

function init() {
    const $realtors = $('[data-place-realtors]');
    const realtorsItems = document.querySelectorAll('[data-realtor-list-item]').length;

    document.querySelectorAll('[data-past-sales-report-preview]').forEach(el => {
        el.addEventListener('click', () => {
            openTransactionDetailPopin(MA.Context.requestId, el.dataset.pastSalesReportPreview);
        });
    });

    handleGetPdfForm();

    RealtorMap.initializeShowRealtorDetails('realtor-contact');
    initializeRealtorMessagePopin(
        'Page prix',
        'realtor:message_form',
        'from:prices:realtors_list',
        'prices',
    );

    Ga.set('dimension10', realtorsItems);
    Wa.setDisplayTracking($realtors);
    Wa.setClickTracking();
}

export function domReady() {
    init();
}
